export const TANK_FIELDS = ["fresh", "waste", "waste2", "waste3"];

export const TEMP_FIELDS = ["menTemp", "womenTemp", "utilityTemp"];

export const dashboardCardSx = {
  background: "#202940",
  border: "1px solid rgba(255, 255, 255, 0.08)",
  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
};

export const dashboardInputSx = {
  "& .MuiInputBase-root": {
    backgroundColor: "rgba(26, 32, 53, 0.8)",
    color: "rgba(255, 255, 255, 0.9)",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.18)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(73, 163, 241, 0.65)",
  },
  "& .MuiInputBase-input::placeholder": {
    color: "rgba(255, 255, 255, 0.55)",
    opacity: 1,
  },
};